/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import type OAuthCredentialsAdminType from '@jira/spa-apps__admin-oauth-credentials-consumer/src/AdminOauthCredentialsConsumerAdminOAuthCredentialsShell.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

// oxlint-disable-next-line @typescript-eslint/no-explicit-any
export const LazyOAuthCredentialsAdmin: LazyComponent<React.ComponentType<Record<any, any>>> =
	lazyForPaint<typeof OAuthCredentialsAdminType>(() =>
		markAsProductBundleReady(
			import(
				/* webpackChunkName: "async-admin-oauth-credentials", jiraSpaEntry: "async-admin-oauth-credentials" */ '@jira/spa-apps__admin-oauth-credentials-consumer/src/AdminOauthCredentialsConsumerAdminOAuthCredentialsShell.tsx'
			),
		),
	);

const AsyncOAuthCredentialsAdmin = (): React.JSX.Element => (
	<LazyPage Page={LazyOAuthCredentialsAdmin} pageId="admin-oauth-credentials" shouldShowSpinner />
);

export default AsyncOAuthCredentialsAdmin;
